module.exports = __webpack_public_path__ + "9e6126541571dcbd78cd7dd2da2d6a14.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PG.svg
// module id = 5hbt
// module chunks = 0